<script lang="ts" setup>
import { useAuth0 } from '@auth0/auth0-vue'

const auth0 = useAuth0()
const isAway = ref(false)
const mounted = ref(false)
onMounted(() => {
  mounted.value = true
})
const checkAuth = async () => {
  if (auth0?.idTokenClaims?.value?.exp) {
    if (new Date(auth0.idTokenClaims.value.exp * 1000).toISOString() < new Date().toISOString()) {
      auth0.logout()
      return
    }
    isAway.value = true
    localStorage.setItem('auth0Token', auth0.idTokenClaims.value.__raw || '')
  }
  else {
    isAway.value = true
    localStorage.setItem('auth0Token', '')
    console.log('User is not authenticated')
  }
}
checkAuth()
watch(() => auth0?.idTokenClaims?.value?.__raw, () => {
  checkAuth()
})
</script>

<template>
  <BlockOverlay
    v-if="mounted"
    v-slot="slotProps"
  >
  <div class="" v-if="slotProps.display === 'await'" >await</div>
    <NuxtLayout v-if="slotProps.display === 'unblock'">
      <NuxtErrorBoundary>
        <template #error="{ error }">
          <p>An error occurred: {{ error }}</p>
        </template>
        <NuxtPage />
      </NuxtErrorBoundary>
    </NuxtLayout>
  </BlockOverlay>
</template>
